import React from "react";
import { useFlaggingSystem } from "./container";
import { FlagItem } from "./flag-item";
import { FlaggerMenu } from "./flag-menu";

/** `menu` replaces the Add Flag dropdown, e.g. with a sheet on phones. */
export const FlaggingSystem = React.memo(
  ({ menu }: { menu?: React.ReactNode }) => {
    const { isMuted, updateActionFlag, hasError, room } = useFlaggingSystem();

    if (!room?.id) return null;

    return (
      <>
        <div className="w-full space-y-2">
          <div className="w-full space-y-2">
            {!isMuted && room.actionFlag && (
              <FlagItem flagType={room.actionFlag} roomId={room.id} />
            )}
          </div>
          {menu ?? (
            <FlaggerMenu room={room} updateActionFlag={updateActionFlag} />
          )}
          {hasError ? (
            <div className="flex px-3 mb-2 space-x-2 border rounded bg-error/25 border-error">
              <span className="text-foreground"> something went wrong</span>
            </div>
          ) : null}
        </div>
      </>
    );
  }
);
